// extracted by mini-css-extract-plugin
export default {"anchor":"RecentChatContextMenu_anchor__0-xwN","menu":"RecentChatContextMenu_menu__zXa7n","danger":"RecentChatContextMenu_danger__+Rnyz"};